export default __webpack_public_path__ + "d7ed5c6e7484bd8c65df75b4c61276f2.png";